module.exports = __webpack_public_path__ + "static/media/birthday-party-banner.174ff11d.jpg";